'use es6';

import * as ImmutableAPI from 'crm_data/api/ImmutableAPI';
import AssociationTypeToAssociationTypeId from 'crm_data/associations/AssociationTypeToAssociationTypeId';
import { Map as ImmutableMap, Set as ImmutableSet, List } from 'immutable';
export const LIMIT_PER_TYPE = 100;
const API = 'associations/v1/associations/';
const getFirstPageRequestBody = keys => {
  return keys.reduce((acc, key) => {
    const objectType = key.get('objectType');
    const associationType = AssociationTypeToAssociationTypeId.get(key.get('associationType'));
    if (acc.objectIdsByType && acc.objectIdsByType[objectType]) {
      acc.objectIdsByType[objectType] = acc.objectIdsByType[objectType].add(key.get('objectId'));
    } else {
      acc.objectIdsByType[objectType] = ImmutableSet([key.get('objectId')]);
    }
    if (!acc.associationTypeIdsByCategory.HUBSPOT_DEFINED.includes(associationType)) {
      acc.associationTypeIdsByCategory.HUBSPOT_DEFINED.push(associationType);
    }
    return acc;
  }, {
    objectIdsByType: {},
    associationTypeIdsByCategory: {
      HUBSPOT_DEFINED: []
    }
  });
};
const formatFirstPageResponse = response => {
  const associations = response.reduce((acc, result) => {
    const objectId = `${result.get('fromObjectId')}`;
    const objectType = result.get('fromObjectType');
    const associationType = AssociationTypeToAssociationTypeId.findKey(associationId => {
      return associationId === result.get('associationTypeId');
    });
    return acc.set(ImmutableMap({
      objectType,
      associationType,
      objectId
    }), result.get('results'));
  }, ImmutableMap());
  return associations.map(association => {
    return association.update('results', idList => idList.reverse());
  });
};
export function fetchFirstPage(keys) {
  const isFetchingOneTypeAndId = keys.groupBy(value => List([value.get('objectId'), value.get('objectType')])).size === 1;
  if (isFetchingOneTypeAndId) {
    const body = getFirstPageRequestBody(keys);
    return ImmutableAPI.post(`${API}first-page-batch?limitPerType=${LIMIT_PER_TYPE}`, body).then(formatFirstPageResponse);
  } else {
    const idsByAssociationType = keys.groupBy(value => value.get('associationType'));
    // The batch endpoint only allows for 100 requests per type
    const groupedIdsByType = idsByAssociationType.flatMap(list => list.groupBy((item, index) => List([item.get('associationType'), Math.floor(index / 100)])));
    const requests = groupedIdsByType.map(id => {
      const body = getFirstPageRequestBody(id);
      return ImmutableAPI.post(`${API}first-page-batch?limitPerType=${LIMIT_PER_TYPE}`, body);
    });

    // WARNING: Do not swap this out for native promises
    // This only works if using Q because of done()
    return Promise.all(requests.valueSeq().toArray()).then(responses => {
      return responses.reduce((acc, response) => {
        /* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
        return acc.concat(response);
      }, List());
    }).then(formatFirstPageResponse);
  }
}